<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.shiftPlan.new')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <!-- <li class="breadcrumb-item">
                        <router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link>
                    </li> -->
                    <li class="breadcrumb-item">
                        <router-link to="/prd/shiftPlan"><span>{{$t('tlt.shiftPlan')}}</span></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/shiftPlan/edit"><span>{{$t('tlt.shiftPlan.new')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('shiftPlan')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('shiftPlan')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row"> 
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.shiftPlan.output')}}:</label>
                                <input v-validate="'required'" name="output"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('output') }"
                                    v-model="output" type="text">
                                <span v-show="errors.has('output')" class="lbl-obg">
                                    {{ errors.first('output') }}
                                </span>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg"></span>{{$t('lbl.shiftPlan.operationRate')}}:</label>
                                <input class="form-control form-control-sm" v-model="operationRate" type="text">
                            </div> 
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftPlan.status')}}:</label>
                                <!-- <input class="form-control form-control-sm" v-model="status" type="text"> -->
                                 <select class="form-control" type="text" v-model="status">
                                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                                    <option value="Y">{{ $t("lbl.shiftPlan.active") }}</option>
                                    <option value="N">{{ $t("lbl.shiftPlan.disactive") }}</option>                                    
                                </select>
                            </div>                        
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>



<script>
    import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions,
        mapState
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionPlan/ShiftPlan";
    import dimSearch from "@/components/MMFDimSearch";
    import MmfMonthpicker from '@/components/MmfMonthpicker';

    const {
        mapFields
    } = createHelpers({
        getterType: 'shiftPlan/getField',
        mutationType: 'shiftPlan/updateField',
    });
    export default {
        data() {
            return {
                         
            }
        },        
        computed: {
            ...mapFields(fields),
            ...mapState({
                
            }),          
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            dimSearch,
            MmfMonthpicker
        }
    };
</script>